import { render, staticRenderFns } from "./gift-detail.vue?vue&type=template&id=afde8516&scoped=true"
import script from "./gift-detail.vue?vue&type=script&lang=js"
export * from "./gift-detail.vue?vue&type=script&lang=js"
import style0 from "./gift-detail.vue?vue&type=style&index=0&id=afde8516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afde8516",
  null
  
)

export default component.exports